import React from 'react';
import Modal from 'react-modal';
import './GenericConfirmModal.css';

/**
 * GenericConfirmModal Component
 * 
 * A reusable modal for confirming actions (like deletions).
 * 
 * @param {Object} props
 * @param {boolean} props.isOpen - Controls modal visibility
 * @param {Function} props.onClose - Callback to close the modal
 * @param {Function} props.onConfirm - Callback when action is confirmed
 * @param {string} props.title - Modal title
 * @param {React.ReactNode} props.message - Modal message/content
 * @param {string} [props.confirmText='Confirm'] - Text for confirm button
 * @param {string} [props.cancelText='Cancel'] - Text for cancel button
 * @param {boolean} [props.isDestructive=false] - If true, confirm button is styled as danger
 * @param {boolean} [props.loading=false] - If true, buttons are disabled and loading state shown
 */
const GenericConfirmModal = ({
  isOpen,
  onClose,
  onConfirm,
  title,
  message,
  confirmText = 'Confirm',
  cancelText = 'Cancel',
  isDestructive = false,
  loading = false
}) => {
  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={!loading ? onClose : undefined}
      contentLabel={title}
      className="modal generic-confirm-modal"
      overlayClassName="modal-overlay"
    >
      <div className="modal-header">
        <h2>{title}</h2>
        {!loading && (
          <button className="modal-close-btn" onClick={onClose}>&times;</button>
        )}
      </div>

      <div className="modal-body">
        {typeof message === 'string' ? <p>{message}</p> : message}
      </div>

      <div className="modal-footer">
        <button
          className="btn-secondary"
          onClick={onClose}
          disabled={loading}
        >
          {cancelText}
        </button>
        <button
          className={`btn-primary ${isDestructive ? 'btn-danger' : ''}`}
          onClick={onConfirm}
          disabled={loading}
        >
          {loading ? 'Processing...' : confirmText}
        </button>
      </div>
    </Modal>
  );
};

export default GenericConfirmModal;
